import { TextInput, FileUploader, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect} from "react";
import { WizarContext } from "contexts/WizardContext";
import { corporateAhvActionCreator } from "contexts/WizardContext";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import GlobalContext from "contexts/GlobalContext";
import { initialWizardFormState } from "contexts/WizardContext";

const Ahv = ({ errors, setErrors }) => {
  const translate = useTranslator();
  const { state, dispatch } = useContext(WizarContext);
  let corporateAhv = state.corporate.ahv;
  let corporateAhvErrors = errors.corporate.ahv;
  let changState = useCallback((payload) => dispatch(corporateAhvActionCreator(payload)), [dispatch]);

  const resetInputFieldError = (property, error) => {
    const exculdedProperties = ["phone", "mobile", "email"];
    if (!exculdedProperties.includes(property)) {
      setErrors((errorsState) => ({
        ...errorsState,
        corporate: {
          ...errorsState.corporate,
          ahv: { ...errorsState.corporate.ahv, [property]: error },
        },
      }));
    } else {
      exculdedProperties.forEach((exculdedProperty) => {
        if (property === exculdedProperty)
          setErrors((errorsState) => ({
            ...errorsState,
            corporate: {
              ...errorsState.corporate,
              ahv: { ...errorsState.corporate.ahv, [exculdedProperty]: error },
            },
          }));
      });
    }
  };

  const { user } = useContext(GlobalContext);
  const userId = user.siaId;

  useEffect(() => {
    if (userId) {
      pgAdapter.getWizardSession(({ data }) => {
        const defaultAhv = { ...initialWizardFormState.corporate.ahv };
        const { ahv } = data?.corporate || {};
        const { year, sum, numberOfEmployees } = ahv || defaultAhv;
        changState({ year, sum, numberOfEmployees });
      });
    }
  }, [userId, changState]);

  const setUserSession = (obj) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = {
        ...data,
        corporate: { ...(data.corporate || {}), ahv: { ...(data?.corporate?.ahv || {}), ...obj } },
      };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };

  return (
    <div className="corporate-ahv-page">
      <div className="sia-margin-03-top"></div>
      <p className="sia-text-11 sia-padding-04-top">{translate('wizard.form.corporate.ahv.lead')}</p>
      <p className="sia-text-11 sia-padding-02-top">{translate('wizard.form.corporate.ahv.sublead')}</p>
      <TextInput
        onBlur={() => {
          if (corporateAhv.year) {
            setUserSession({ year: corporateAhv.year });
          }
        }}
        id={"corporate-page-ahv-year"}
        value={corporateAhv.year}
        onChange={(event, value) => {
          resetInputFieldError("year");
          changState({ year: value });
        }}
        label={translate("wizard.form.corporate.ahv.year.label")}
        placeholder={'2020'}
        required={true}
        invalidPatternText={corporateAhvErrors.year}
        invalidText={corporateAhvErrors.year}
        />
      <TextInput
        onBlur={() => {
          if (corporateAhv.sum) {
            setUserSession({ sum: corporateAhv.sum });
          }
        }}
        id={"corporate-page-ahv-sum"}
        value={corporateAhv.sum}
        onChange={(event, value) => {
          resetInputFieldError("sum");
          changState({ sum: value });
        }}
        label={translate("wizard.form.corporate.ahv.sum.label")}
        placeholder={"123'456'789"}
        required={true}
        invalidPatternText={corporateAhvErrors.sum}
        invalidText={corporateAhvErrors.sum}
      />

      <p className="sia-text-01 sia-padding-03-bottom">{translate("wizard.form.corporate.ahv.category")}</p>

      <FileUploader
        label={translate("wizard.form.corporate.ahv.upload")}
        sizeLimit={500}
        sizeLimitUnit={"KB"}
        files={corporateAhv.ahvFile}
        fileTypes={["pdf"]}
        buttonLabel={"wizard.form.single.education.bachelor.upload.button.label"}
        translate={translate}
        onChange={(event, files, error) => {
          resetInputFieldError("ahvFile");
          changState({ ahvFile: files });
        }}
        onRemove={(event, file, updatedFiles, error) => {
          resetInputFieldError("ahvFile");
          changState({ ahvFile: updatedFiles });
        }}
        invalidText={corporateAhvErrors.ahvFile}
      />

      <TextInput
        onBlur={() => {
          if (corporateAhv.numberOfEmployees) {
            setUserSession({ numberOfEmployees: corporateAhv.numberOfEmployees });
          }
        }}
        id={"corporate-page-ahv-numberOfEmployees"}
        value={corporateAhv.numberOfEmployees}
        onChange={(event, value) => {
          resetInputFieldError("numberOfEmployees");
          changState({ numberOfEmployees: value });
        }}
        label={translate("wizard.form.corporate.ahv.numberOfEmployees.label")}
        placeholder={"10"}
        required={true}
        invalidPatternText={corporateAhvErrors.numberOfEmployees}
        invalidText={corporateAhvErrors.numberOfEmployees}
      />
    </div>
  );
};

export default Ahv;
